import styled from 'styled-components';

import { ANIM, ART_STYLE, COLORS, REDUCED_MOTION, SPACE } from '../../../../theme/tokens';

/** The card's kebab: a small solid disc over the thumbnail's top-right corner. */
export const Trigger = styled.button<{ $open: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 999px;
  border: 1px solid ${COLORS.hairline};
  background: ${COLORS.surfaceCard};
  color: ${({ $open }) => ($open ? COLORS.text : COLORS.icon)};
  box-shadow: ${COLORS.menuShadow};
  cursor: pointer;
  transition:
    color ${ANIM.INTERACT_MS}ms ${ANIM.EASE},
    background ${ANIM.INTERACT_MS}ms ${ANIM.EASE};

  &:hover,
  &:focus-visible {
    color: ${COLORS.text};
    background: ${COLORS.surfaceInset};
  }

  &:disabled {
    cursor: default;
    opacity: 0.45;
  }
`;

/**
 * The dropped list, portalled to the body and placed from the trigger's box (fixed), so the strip's
 * horizontal scroller never clips it. Same material as the shared ActionMenu panel.
 */
export const Panel = styled.div<{ $shown: boolean }>`
  position: fixed;
  z-index: 1000;
  min-width: ${ART_STYLE.MENU_WIDTH_PX}px;
  box-sizing: border-box;
  padding: ${SPACE[4]};
  display: flex;
  flex-direction: column;
  gap: ${SPACE[2]};
  border-radius: 14px;
  border: 1px solid ${COLORS.panelBorder};
  background: ${COLORS.surfaceInset};
  box-shadow: ${COLORS.menuShadow};
  opacity: ${({ $shown }) => ($shown ? 1 : 0)};
  transform: translateY(${({ $shown }) => ($shown ? '0' : `-${ART_STYLE.CARD_LIFT_PX}px`)});
  transition:
    opacity ${ANIM.INTERACT_MS}ms ${ANIM.EASE},
    transform ${ANIM.INTERACT_MS}ms ${ANIM.EASE};

  ${REDUCED_MOTION} {
    transition: none;
    transform: none;
  }
`;
